import type { CorpusData } from './types'
import api from '.'

export async function getCorpus(): Promise<CorpusData> {
  const res = await api.get<CorpusData>('/corpus')
  return res.data
}
